<script setup lang="ts">
import { useCondition } from "./useCondition";

import ConditionOperatorIcon from "./ConditionOperatorIcon.vue";

interface Props {
  conditionId: number;
}
const props = defineProps<Props>();

const ctx = useCondition(() => props.conditionId);
</script>

<template>
  <div class="condition-input-operator">
    <h4 class="label mt-0">
      {{ $t("labels.operator") }}
    </h4>
    <div class="condition-input-operator__list mt-2 mb-4">
      <button
        v-for="operator of ctx.validOperators"
        :key="operator"
        type="button"
        class="condition-input-operator__button"
        :class="{ '-is-active': ctx.condition.operator === operator }"
        :title="$t(`valueOperators.${operator}`)"
        @click="ctx.validUpdateKey('operator', operator)"
      >
        <condition-operator-icon
          :operator="operator"
          class="condition-input-operator__icon"
        />
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.condition-input-operator {
  &__list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-auto-flow: column;
    gap: 0.75rem;
    column-gap: 1rem;
    width: min-content;
  }

  &__button {
    width: 2.5rem;
    height: auto;
    aspect-ratio: 1 / 1;
    text-align: center;
    background-color: transparent;
    border: none;
    position: relative;
    padding: 0;
    color: var(--color-text-light);
    transition: color 200ms ease;
    display: flex;
    justify-content: center;
    align-items: center;

    &::before {
      content: "";
      position: absolute;
      display: block;
      width: 75%;
      height: 75%;
      top: 12.5%;
      left: 10%;
      border: 1px solid currentColor;
      transform: rotate(45deg);
    }

    &:nth-child(2n) {
      transform: translateX(1rem) translateY(-0.5rem);
    }

    &:hover {
      color: var(--color-text-medium);
    }
    &:active {
      color: var(--color-text);
    }

    &.-is-active {
      color: var(--color-text);
      font-weight: 700;
      &::before {
        outline: 1px solid var(--color-text);
        box-shadow: 0 0 0 0.125rem var(--color-shadow-1);
      }
    }
  }

  &__icon {
    width: 16px;
    height: 16px;
  }
}
</style>
